import React, { useMemo } from "react";
import { useParams } from "react-router";
import { useUserInfo } from "../../hooks/useUserInfo";
import TableauEmbed from "./TableauEmbed";
import useSession from "../../hooks/useSession";
import { getAllowedTableauReports } from "../../utils/tableauConfig";


export default function ReportRouter() {
  const { reportPath } = useParams();
  const { parsedTenantAttribute, loadingInfo } = useUserInfo();
  const { rolesSet } = useSession();

const reports = useMemo(
  () => getAllowedTableauReports(parsedTenantAttribute, rolesSet),
  [parsedTenantAttribute, rolesSet]
);

const report = reports.find((r) => r.path === reportPath);

if (loadingInfo) return <div>Loading reports…</div>;
if (!report) return <div>Report not found.</div>;


const allowed =
  !report.roles?.length || report.roles.some((role) => rolesSet.has(role));

if (!allowed) return <div>You don’t have access to this report.</div>;

return <TableauEmbed key={report.path} src={report.src} />;
}
